<template>
  <Container type="card-full" drankColor v-loading="loading">
    <!-- <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div> -->
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">协议编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectptccode" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">需求编号</div>
          <div class="field">
            <el-input v-model.trim="query.demandcode" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">项目名称</div>
          <div class="field">
            <el-input v-model.trim="query.projectname" clearable></el-input>
          </div>
        </div>
        <!-- <div class="searchItem">
          <div class="label">平台编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectno" clearable></el-input>
          </div>
        </div> -->
        <div class="searchItem">
          <div class="label">采购人</div>
          <div class="field">
            <el-input v-model.trim="query.comname" clearable></el-input>
          </div>
        </div>
        <div class="searchItem" v-if="+query.comtype === 2 || +loginUser.comtype === 1">
          <div class="label">经办人</div>
          <div class="field">
            <el-input v-model.trim="query.pUsername" :disabled="pUsernameDisabled" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">状态</div>
          <div class="field">
            <el-select v-model="query.status" :clearable="true" placeholder="请选择">
              <el-option v-for="item in projectStatusList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">交易结果</div>
          <div class="field">
            <el-select v-model="query.failproject" :clearable="true" placeholder="请选择">
              <el-option v-for="item in failProjectStatusList" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">评审方法</div>
          <div class="field">
            <el-select v-model="query.doneflg" :clearable="true" placeholder="请选择">
              <el-option v-for="item in projectdoneflgList" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">报名方式</div>
          <div class="field">
            <el-select v-model="query.projectisinvite" :clearable="true" placeholder="请选择">
              <el-option label="公开" :value="0"></el-option>
              <el-option label="邀请" :value="1"></el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">项目员</div>
          <div class="field">
            <el-input v-model.trim="query.projectCusername" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">业务员</div>
          <div class="field">
            <el-input v-model.trim="query.ptcUsername" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">建项时间</div>
          <div class="field" style="width: 400px">
            <el-date-picker v-model="query.ProjectbegTime" type="date" format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd" placeholder="选择日期">
            </el-date-picker>
            <div style="margin: 0 10px">至</div>
            <el-date-picker v-model="query.ProjectendTime" type="date" format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd" placeholder="选择日期">
            </el-date-picker>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type="primary" @click="search">查询</el-button>
            <el-button v-if="+query.comtype === 1" type="primary" @click="showButton = !showButton">{{
              showButton ? "收起"
                : "展开"
            }}</el-button>
            <!-- <el-checkbox
              v-model="query.isfald_p"
              @change="getPageList"
              style="padding: 10px"
              v-if="+query.comtype === 1"
              >不包含失败项目</el-checkbox
            > -->
          </div>
        </div>
      </div>
      <div style="display: flex; align-items: center" v-if="+query.comtype === 1">
        <el-collapse-transition>
          <div v-show="showButton" style="padding: 10px">
            <el-radio-group v-model="areaid" @change="getPageList">
              <el-radio-button v-for="item in this.areaList" :key="item.dptareacode" :label="item.dptareacode">{{
                item.label
              }}</el-radio-button>
            </el-radio-group>
          </div>
        </el-collapse-transition>
      </div>
    </div>
    <vggrid :list="list" tableheight="600" flexname="" :cols="cols" :showfooter="false" :loading="loading" :showPage="true"
      :resizable="true" :defaultPage="10" :total="query.total" @cellClick="cellClick" @cellDblClick="viewProject"
      @pagechange="pagechange" :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick">
      <template slot="btn">
        <div style="display: flex; justify-content: space-between">
          <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
          <div style="float: left; line-height: 41.5px" v-if="+this.$store.getters.loginUser.comtype != 3">
            【预算合计】：{{ amt.price | Thousands }}元
          </div>
        </div>
      </template>
    </vggrid>
  </Container>
</template>
<script>
import request from "@/utils/request";
import MenuBtn from "../common/menuBtn";
import vggrid from "../common/vggrid";
import dayjs from "dayjs";
import utils from "../../assets/js/utils";
export default {
  name: "projectIndex",
  data() {
    return {
      loginUser: this.$store.getters.loginUser,
      menuid: this.$route.query.menuid,
      pUsernameDisabled: false,
      list: [],
      amt: {},
      areaid: 0, //查询地区id
      btn: {},
      btnClone: {},
      loading: false,
      btnLoading: false,
      showButton: true,
      cols: [],
      project: {},
      projectStatusList: [],
      failProjectStatusList: [],
      projectdoneflgList: [],
      areaList: [],
      query: {
        cosid: this.$store.getters.loginUser.cosid,
        userid: this.$store.getters.loginUser.userid,
        comid: this.$store.getters.loginUser.comid,
        comtype: this.$store.getters.loginUser.comtype,
        total: 0,
        limit: 10,
        offset: 0,
      },
    };
  },
  created() {
    this.$on("ADD", () => this.addProject());
    this.$on("CHG", () => this.chgProject());
    this.$on("DEL", () => this.delProject());
    this.$on("SETPM", () => this.setPm());
    this.$on("BATCHPSU", () => this.batchPsu());
    this.$on("INVITEPSU", () => this.invatedCom());
    this.$on("SETPG", () => this.setPg());
    this.$on("PEXPERT", () => this.pexpert());
    this.$on("FBXMGG", () => this.projectNotice());
    // this.$on('BGGG', () => this.projectChangeNotice())
    // this.$on('CQGG', () => this.projectClarificationNotice())
    // this.$on('ZZGG', () => this.projectTerminationNotice())
    // this.$on('FBGG', () => this.projectBulletinNotice())
  },
  activated() {
    this.init();
    // this.TBJJbtn()
    this.getPageList();
    this.getProjectStatusList();
    this.getfailProjectStatusList();
    this.getProjectdoneflgList()
    if (this.query.comtype === 1) {
      this.getareaList();
    }
  },
  filters: {
    Thousands(val) {
      return val ? utils.comdify(val) : 0;
    },
  },
  mounted() {
    if (this.cols.length === 0) {
      if (+this.$store.getters.loginUser.comtype === 3) {
        this.cols.push(
          {
            type: "index",
            fieldtype: "I",
            title: "行号",
            calculExpr: "",
            width: 50,
          },
          {
            field: "projectcode",
            fieldtype: "C",
            title: "项目编号",
            calculExpr: "",
            addNewRowFlg: false,
            width: 150,
            slots: {
              default: ({ row }) => {
                return [
                  <div>
                    <div class="code" onClick={() => this.viewProject({row})}>{row.projectcode}</div>
                </div>
                ] 
              }
            }
          },
          {
            field: "projectptccode",
            fieldtype: "C",
            title: "协议/需求编号",
            calculExpr: "",
            addNewRowFlg: false,
            width: 150,
            align: "center",
            slots: {
              default: ({ row }) => {
                return [
                  <div style="text-align: center">
                    <div>{row.projectptccode}</div>
                    <div>{row.demandcode}</div>
                </div>
                ] 
              }
            }
          },
          // { field: 'projectno', fieldtype: 'C', title: '平台编号',calculExpr:'',addNewRowFlg: false, width: 150},
          {
            field: "projectname",
            fieldtype: "C",
            title: "项目名称",
            calculExpr: "",
            addNewRowFlg: false,
            slots: {
              default: ({ row }) => {
                return [
                  <span class="code name" onClick={() => this.viewProject({row})}>{row.projectname}</span>
                ] 
              }
            }
          },
          // { field: 'projectdesc', fieldtype: 'C', title: '项目内容',calculExpr:'',addNewRowFlg: false},
          {
            field: "comfullname",
            fieldtype: "C",
            title: "采购人",
            calculExpr: "",
            addNewRowFlg: false,
          },
          // { field: 'dailiname', fieldtype: 'C', title: '代理人',calculExpr:'',addNewRowFlg: false},
          // { field: 'projectlimitamtdesc', fieldtype: 'C', title: '项目预算',calculExpr:'',addNewRowFlg: false},
          {
            field: "prsflgdesc",
            fieldtype: "C",
            title: "交易方式",
            calculExpr: "",
            addNewRowFlg: false,
            width: 80,
          },
          {
            field: "projectisinviteCN",
            fieldtype: "C",
            title: "报名方式",
            calculExpr: "",
            addNewRowFlg: false,
            width: 80,
          },
          // { field: 'projectisinviteCN', fieldtype: 'C', title: '报名方式',calculExpr:'',addNewRowFlg: false, width: 80},
          {
            field: "projectstatusname",
            fieldtype: "C",
            title: "状态",
            calculExpr: "",
            addNewRowFlg: false,
            width: 80,
          },
          {
            field: "projectrecusername",
            fieldtype: "C",
            title: "项目员",
            calculExpr: "",
            addNewRowFlg: false,
            width: 80,
          },
          {
            field: "projecttime",
            fieldtype: "T",
            title: "建项时间",
            calculExpr: "",
            addNewRowFlg: false,
            formatter: ["toDateString", "yyyy-MM-dd"],
            width: 100,
          }
        );
      } else {
        this.cols.push(
          {
            type: "index",
            fieldtype: "I",
            title: "行号",
            calculExpr: "",
            width: 50,
          },
          {
            field: "projectcode",
            fieldtype: "C",
            title: "项目编号",
            calculExpr: "",
            addNewRowFlg: false,
            width: 150,
            slots: {
              default: ({ row }) => {
                return [
                  <span class="code" onClick={() => this.viewProject({row})}>{row.projectcode}</span>
                ] 
              }
            }
          },
          {
            field: "projectptccode",
            fieldtype: "C",
            title: "协议/需求编号",
            calculExpr: "",
            addNewRowFlg: false,
            width: 150,
            align: "center",
            slots: {
              default: ({ row }) => {
                return [
                  //  
                  <div style="text-align: center;">
                    <div>{row.projectptccode}</div>
                    <div style="margin-top: 4px;">{row.demandcode}</div>
                  </div>
                ] 
              }
            }
          },
          // { field: 'projectno', fieldtype: 'C', title: '平台编号',calculExpr:'',addNewRowFlg: false, width: 150},
          {
            field: "projectname",
            fieldtype: "C",
            title: "项目名称",
            calculExpr: "",
            addNewRowFlg: false,
            slots: {
              default: ({ row }) => {
                return [
                  <span class="code name" onClick={() => this.viewProject({row})}>{row.projectname}</span>
                ] 
              }
            }
          },
          // { field: 'projectdesc', fieldtype: 'C', title: '项目内容',calculExpr:'',addNewRowFlg: false},
          {
            field: "comfullname",
            fieldtype: "C",
            title: "采购人",
            calculExpr: "",
            addNewRowFlg: false,
          },
          {
            field: "pusername",
            fieldtype: "C",
            title: "经办人",
            calculExpr: "",
            addNewRowFlg: false,
            width: 80,
          },
          // { field: 'dailiname', fieldtype: 'C', title: '代理人',calculExpr:'',addNewRowFlg: false},
          {
            field: "projectlimitamtdesc",
            fieldtype: "C",
            title: "项目预算",
            calculExpr: "",
            addNewRowFlg: false,
          },
          {
            field: "prsflgdesc",
            fieldtype: "C",
            title: "交易方式",
            calculExpr: "",
            addNewRowFlg: false,
            width: 80,
          },
          {
            field: "projectisinviteCN",
            fieldtype: "C",
            title: "报名方式",
            calculExpr: "",
            addNewRowFlg: false,
            width: 80,
          },
          // { field: 'projectisinviteCN', fieldtype: 'C', title: '报名方式',calculExpr:'',addNewRowFlg: false, width: 80},
          {
            field: "projectstatusname",
            fieldtype: "C",
            title: "状态",
            calculExpr: "",
            addNewRowFlg: false,
            width: 80,
          },
          {
            field: "projectrecusername",
            fieldtype: "C",
            title: "项目员",
            calculExpr: "",
            addNewRowFlg: false,
            width: 80,
          },
          { field: 'projectsusername', fieldtype: 'C', title: '业务员', calculExpr: '', addNewRowFlg: false, width: 80 },
          {
            field: "projecttime",
            fieldtype: "T",
            title: "建项时间",
            calculExpr: "",
            addNewRowFlg: false,
            formatter: ["toDateString", "yyyy-MM-dd"],
            width: 100,
          }
        );
      }
    }
  },
  watch: {},
  components: { MenuBtn, vggrid },
  methods: {
    async getProjectStatusList() {
      this.projectStatusList = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "projectstatus" },
      });
    },
    async getfailProjectStatusList() {
      this.failProjectStatusList = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "failproject" },
      });
    },
    async getProjectdoneflgList() {
      this.projectdoneflgList = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "projectdoneflg" },
      });
    },
    btnClick(code) {
      this.$emit(code);
    },
    vggridClick(code, row) {
      this.project = row;
      this.$emit(code, row);
    },
    btnmenuclick(btn) {
      this.btn = btn;
      this.btnClone = _.cloneDeep(btn);
    },
    async init() {
      this.list = [];
      this.btnLoading = false;
      this.areaList = [];
      this.project = {};
      if (+this.query.comtype === 2 && +this.$store.getters.loginUser.roletype === 2) {
        this.query.pUsername = this.$store.getters.loginUser.username
        this.pUsernameDisabled = true
      }
    },
    async projectAnnouncement(name, wmenudatawhere) {
      if (!this.project.projectid) {
        this.$message.warning("请选择一个项目!");
        return;
      }
      let wmenu = await request({
        method: "get",
        url: "/ywgl/wmenu/getWmenuId",
        params: { wmenudatawhere: wmenudatawhere },
      });
      let form = {
        project: this.project,
        pjnoticefromid: this.project.projectid,
        wmenuid: wmenu[0].wmenuid,
        wmenuname: name,
        wmenudatawhere: wmenudatawhere,
      };
      this.$router.push({ name: "pjnoticeIndex", params: { form: form } });
    },
    async TBJJbtn() {
      //供应商进去操作列表
      if (+this.$store.getters.loginUser.comtype === 3) {
        let nowdate = await request({
          method: "get",
          url: "xtgl/sysdata",
        });
        if (
          this.cols[this.cols.length - 1].title == "操作 " &&
          !this.btn.isOperate
        )
          this.cols.pop();
        this.cols.push({
          title: "操作 ",
          width: 100,
          showOverflow: true,
          slots: {
            default: ({ row }) => {
              if (
                new Date(row.prsbmendtime).getTime() <=
                new Date(nowdate).getTime() &&
                new Date(row.prsbjendtime).getTime() >
                new Date(nowdate).getTime()
              ) {
                if (+row.prsflg === 1) {
                  return [
                    <vxe-button
                      type="primary"
                      onClick={this.goJJorTB.bind(this, row)}
                    >
                      竞价
                    </vxe-button>,
                  ];
                } else if (+row.prsflg === 2) {
                  return [
                    <vxe-button
                      type="primary"
                      onClick={this.goJJorTB.bind(this, row)}
                    >
                      投标
                    </vxe-button>,
                  ];
                }
              } else {
                return [
                  <vxe-button
                    type="primary"
                    onClick={this.goJJorTB.bind(this, row)}
                  >
                    查看
                  </vxe-button>,
                ];
              }
            },
          },
        });
      }
    },
    async goJJorTB(row) {
      this.project = row;

      this.$router.push({
        name: "projectView",
        params: {
          projectid: this.project.projectid,
          psuid: this.project.psuid,
          innerbtn: this.btn.inner,
        },
      });
    },
    async projectNotice() {
      if (!this.project.projectid) {
        this.$message.warning("请选择一个项目!");
        return;
      }
      let pmmxList = await request({
        method: "get",
        url: "/xmgl/project/getPmmxList",
        params: { projectid: this.project.projectid },
      });
      if (!pmmxList.length) {
        this.$message.warning("请设置采购清单!");
        setTimeout(() => {
          this.$router.push({
            name: "pmmxIndex",
            params: { form: this.project },
          });
        }, 900);
        return;
      }
      if (!this.project.prsbmbegtime) {
        this.$message.warning("请设置项目规则!");
        setTimeout(() => {
          this.$router.push({
            name: "prsForm",
            params: { form: this.project, type: 1 },
          });
        }, 900);
        return;
      }
      let pgList = await request({
        method: "get",
        url: "/xmgl/project/getPgList",
        params: { projectid: this.project.projectid },
      });
      if (!pgList.length) {
        this.$message.warning("请设置评分项目!");
        setTimeout(() => {
          this.$router.push({
            name: "pgIndex",
            params: { form: this.project, type: 1 },
          });
        }, 900);
        return;
      }
      let pexpertList = await request({
        url: "/xmgl/project/getPexpertList",
        method: "get",
        params: { projectid: this.project.projectid },
      });
      let psuList = await request({
        method: "get",
        url: "/xmgl/project/getInvitePsuListByProjectId",
        params: { projectid: this.project.projectid },
      });

      if (Number(this.project.projectisinvite) === 1 && psuList.length === 0) {
        this.$message.warning("请邀请供应商!");
        setTimeout(() => {
          this.$router.push({
            name: "pInviteForm",
            params: { form: this.project, type: 1 },
          });
        }, 900);
        return;
      }
      let nowdate = await request({
        method: "get",
        url: "xtgl/sysdata",
      });
      if (Number(this.project.projectstatus) == 10) {
        if (
          new Date(this.project.prsbmendtime).getTime() <=
          new Date(nowdate).getTime()
        ) {
          this.$message.warning("该项目报名已结束，请重新设置项目规则!");
          setTimeout(() => {
            this.$router.push({
              name: "prsForm",
              params: { form: this.project, type: 1 },
            });
          }, 900);
          return;
        }
      }
      this.$router.push({
        name: "projectNotice",
        params: { projectid: this.project.projectid, type: 1 },
      });
    },
    async batchPsu() {
      if (!this.project.projectid) {
        this.$message.warning("请选择一个项目!");
        return;
      }
      this.$router.push({
        name: "psuBatchForm",
        params: { form: this.project, type: 1 },
      });
    },
    async invatedCom() {
      if (!this.project.projectid) {
        this.$message.warning("请选择一个项目!");
        return;
      }
      if (Number(this.project.projectisinvite) !== 1) {
        this.$message.warning("邀请类项目才能邀请供应商");
        return;
      }
      if (!this.project.prsbmbegtime) {
        this.$message.warning("请先设置项目规则，再邀请供应商!");
        setTimeout(() => {
          this.$router.push({
            name: "prsForm",
            params: { form: this.project, type: 1 },
          });
        }, 900);
        return;
      }
      this.$router.push({
        name: "pInviteForm",
        params: { form: this.project, type: 1 },
      });
    },
    async setPg() {
      if (!this.project.projectid) {
        this.$message.warning("请选择一个项目!");
        return;
      }
      this.$router.push({
        name: "projectReviewRuleIndex",
        params: { projectid: this.project.projectid, type: 1 },
      });
    },
    async viewProject(row) {
      this.project = row.row;
      this.btn = _.cloneDeep(this.btnClone);
      // 邀请供应商按钮
      if (+this.project.projectisinvite === 0) {
        let index = this.btn.inner.findIndex((v) => v.btncode === "INVITEPSU");
        if (index !== -1) {
          this.btn.inner.splice(index, 1);
        }
      }
      // 采购清单按钮
      // 20201023 招标开放采购清单
      // if (+this.project.prsflg === 2) {ETPM')
      //   this.btn.inner.splice(index, 1)
      // }
      // 设置评分规则
      // 网上竞价 及 不需要项目预审时不显示 该按钮
      // if (+this.project.prsflg !== 2 && +this.project.projectisqcheck !== 1 ) {
      if (
        (![3,5].includes(+this.project.projectdoneflg) && +this.project.prsflg === 6) ||
        (this.project.projectisqcheck !== 1 && +this.project.prsflg !== 6)
      ) {
      //   let index = this.btn.inner.findIndex(v => v.btncode === 'S
        let index = this.btn.inner.findIndex((v) => v.btncode === "SETPG");
        console.log(index)
        if (index !== -1) {
          this.btn.inner.splice(index, 1);
        }
      }
      if (this.project.psuid) {
        this.$router.push({
          name: "projectView",
          params: {
            projectid: this.project.projectid,
            psuid: this.project.psuid,
            innerbtn: this.btn.inner,
          },
        });
      } else {
        this.$router.push({
          name: "projectView",
          params: {
            projectid: this.project.projectid,
            innerbtn: this.btn.inner,
          },
        });
      }
    },
    async addProject() {
      this.$router.push({ name: "projectAdd", params: { type: 1 } });
    },
    async chgProject() {
      if (!this.project.projectid) {
        this.$message.warning("请选择一个项目!");
        return;
      }
      if (this.project.projectstatus !== "10") {
        this.$message.warning("项目公告已发布，不能修改！");
        return;
      }
      this.$router.push({
        name: "projectEdit",
        params: { projectid: this.project.projectid },
      });
    },
    async setPm() {
      if (!this.project.projectid) {
        this.$message.warning("请选择一个项目!");
        return;
      }
      this.$router.push({ name: "pmmxIndex", params: { form: this.project } });
    },
    async setRule() {
      if (!this.project.projectid) {
        this.$message.warning("请选择一个项目!");
        return;
      }
      this.$router.push({
        name: "prsForm",
        params: { form: this.project, type: 1 },
      });
    },
    async pexpert() {
      if (!this.project.projectid) {
        this.$message.warning("请选择一个项目!");
        return;
      }
      if (this.project.projectstatus == "10") {
        this.$message.warning("项目还未发布，不能抽取评审人！");
        return;
      }
      switch (this.project.projectstatus) {
        case 10:
          this.$message.warning("项目还未发布，不能抽取评审人！");
          return;
        case 40:
          this.$message.warning("项目评标中，不能抽取评审人！");
          return;
        case 50:
          this.$message.warning("项目定标中，不能抽取评审人！");
          return;
        case 60:
          this.$message.warning("项目归档中，不能抽取评审人！");
          return;
        case 70:
          this.$message.warning("项目已完成，不能抽取评审人！");
          return;
      }
      if (this.project.projectdoneflg === "1") {
        this.$message.warning("价格定标法，不需要抽取评审人评分");
        return;
      }
      // if(!this.project.prswexperts||!this.project.prsnexperts){
      //   this.$message.warning('请先设置评审人数!')
      //   setTimeout(() => {
      //     this.$router.push({name: 'prsForm', params: {form: this.project, type: 1}})
      //   }, 900)
      //   return
      // }
      this.$router.push({
        name: "pexpertForm",
        params: { form: this.project, type: 2 },
      });
    },
    //获取地区list
    async getareaList() {
      let res = await request({
        method: "get",
        url: "/xtgl/dpt/getDptareaList",
        params: { cosid: this.$store.getters.loginUser.cosid },
      });
      this.areaList = res.filter((e) => {
        return +e.dptareause === 1;
      });
      this.areaList.unshift({
        dptareacode: 0,
        label: "全部",
      });
    },
    async delProject() {
      if (!this.project.projectid) {
        this.$message.warning("请选择一个项目!");
        return;
      }
      if (this.project.projectstatus !== "10") {
        this.$message.warning("项目公告已发布，不能删除！");
        return;
      }
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let data = await request({
          url: "/xmgl/project/delProject",
          method: "post",
          data: this.project,
        });
        if (data.issuccess === 1) {
          this.getPageList();
          this.$message.success("删除成功！");
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    async cellClick(row) {
      this.project = row.row;
    },
    async pagechange(page) {
      this.query.offset = page.pageSize * (page.currentPage - 1);
      this.query.limit = page.pageSize;
      this.getPageList();
    },
    search() {
      this.loading = true;
      this.query.offset = 0;
      // if (this.query.ProjectendTime) {
      this.query.projectendTime = dayjs(this.query.ProjectendTime)
        .add(1, "day")
        .format("YYYY-MM-D");
      // }
      this.getPageList();
      this.getAmt()
      this.loading = false;
    },
    async getAmt() {
      this.query.areaid = this.areaid;
      if (+this.query.comtype === 2) {
        let res = await request({
            method: "get",
            url: "/xmgl/project/getPurchaserListAmt",
            params: this.query,
          });
          this.amt = res.amt ? res.amt[0] : {};
      } else {
        let res = await request({
          method: "get",
          url: "/xmgl/project/getAmt",
          params: this.query,
        });
        this.amt = res.amt ? res.amt[0] : {};
      }
     
    },
    async getPageList() {
      // this.loading = true;
      this.query.cosid = this.$store.getters.loginUser.cosid;
      this.query.fromcode = "jjindex";
      this.query.areaid = this.areaid;
      this.query.selectField = `projectcode,prsflg,projectptccode,projectlimitamt,projectname,projecttime,projectid,projectstatus,projectisinvite,projectisqcheck,projectdoneflg,projectstopflg,projectcancelflg`;
      let res;
      if (+this.query.comtype === 3) {
        res = await request({
          method: "get",
          url: "/xmgl/project/getPsuListByComId",
          params: this.query,
        });
      } else if (+this.query.comtype === 2) {
        res = await request({
          method: "get",
          url: "/xmgl/project/getPurchaserPageList",
          params: this.query,
        });
      } 
       else {
          res = await request({
            method: "get",
            url: "/xmgl/project/getPageList",
            params: this.query,
          });
        
      }
      this.list = res.list;
      this.getAmt()
      // this.amt = res.amt ? res.amt[0] : {};
      res.list.forEach((e) => {
        e.projectisinviteCN = +e.projectisinvite === 1 ? "邀请" : "公开";
        e.projectlimitamtdesc = e.projectlimitamt
          ? utils.comdify(e.projectlimitamt)
          : e.projectlimitamt;
      });
      this.query.total = res.count[0].count;
      // this.loading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.transition-box {
  margin-bottom: 10px;
  width: 200px;
  height: 100px;
  border-radius: 4px;
  background-color: #409eff;
  text-align: center;
  color: #fff;
  padding: 40px 20px;
  box-sizing: border-box;
  margin-right: 20px;
}
.name{
  color: #409eff;
  cursor: pointer;
  text-decoration: underline;
}
.code:hover {
  &:hover {
    color: #409eff;
    cursor: pointer;
  }
}
</style>
